import { useEffect } from 'react';

interface SEOProps {
  title: string;
  description: string;
  /** Absolute URL of the social share image (1200×630). Falls back to the
   *  default og:image already in index.html when omitted. */
  image?: string;
  canonical?: string;
  type?: 'website' | 'article';
}

function setMeta(selector: string, attr: string, value: string) {
  let el = document.querySelector<HTMLMetaElement>(selector);
  if (!el) {
    el = document.createElement('meta');
    // parse the attribute from the selector, e.g. name="description" or property="og:title"
    const nameMatch = selector.match(/\[name="([^"]+)"\]/);
    const propMatch = selector.match(/\[property="([^"]+)"\]/);
    if (nameMatch) el.setAttribute('name', nameMatch[1]);
    if (propMatch) el.setAttribute('property', propMatch[1]);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
}

export function SEO({ title, description, image, canonical, type = 'website' }: SEOProps) {
  useEffect(() => {
    document.title = title;

    setMeta('meta[name="description"]', 'content', description);

    setMeta('meta[property="og:title"]', 'content', title);
    setMeta('meta[property="og:description"]', 'content', description);
    setMeta('meta[property="og:type"]', 'content', type);
    if (canonical) {
      let link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        document.head.appendChild(link);
      }
      link.setAttribute('href', canonical);
      setMeta('meta[property="og:url"]', 'content', canonical);
    }

    setMeta('meta[name="twitter:title"]', 'content', title);
    setMeta('meta[name="twitter:description"]', 'content', description);

    if (image) {
      setMeta('meta[property="og:image"]', 'content', image);
      setMeta('meta[name="twitter:image"]', 'content', image);
    }
  }, [title, description, image, canonical, type]);

  return null;
}
